const endpoints = {
  page: {
    get: (slug) => `/web-page/details/${slug}?site=bcoc`,
  },
  urlHistory: {
    getCanonicalByPath: (path) =>
      `/url-history/canonical?site=bcoc&path=${encodeURIComponent(path)}`,
  },
  resource: {
    getById: (id) => `/resources/${id}/details`,
    getReviews: (id) => `/resources/${id}/reviews`,
  },
  review: {
    getById: (id) => `/reviews/${id}`,
  },
  form: {
    getByType: (type) =>
      `/forms?filters[site][code]=BCOC&filters[type]=${type}&populate[successMessage][populate][image]=true&populate[failureMessage][populate][image]=true&pagination[pageSize]=1&pagination[page]=1`,
  },
  formSubmission: {
    submit: `/form-submissions`,
  },
  download: {
    verifyByRecaptchaToken: (token) =>
      `/download/verify/${encodeURIComponent(token)}`,
  },
  faq: {
    getSupportQuestionsByCategory: (page) => {
      const encodedPage = encodeURIComponent(page);
      return `/support-categories?sort[0]=priority:asc&filters[page][$eq]=${encodedPage}&populate[questions][fields][0]=question&populate[questions][fields][1]=answer&populate[questions][fields][2]=priority&fields[0]=name&fields[1]=page&fields[2]=heading&fields[3]=priority&fields[4]=id&pagination[pageSize]=10&pagination[page]=1`;
    },
  },
  concept: {
    getById: (id) => `/concepts/${id}`,
  },
  accessRequest: {
    create: "/access-requests",
  },
};

export default endpoints;
